import { notification } from "antd";
import { faClipboard } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ReactDOMServer from "react-dom/server";

export const copyToClipboard = (text: string, description?: string): void => {
  const textAreaElement = document.createElement("textarea");
  textAreaElement.innerText = text;

  document.body.appendChild(textAreaElement);
  textAreaElement.select();
  document.execCommand("copy");

  clipboardNotification(description || text);

  textAreaElement.remove();
};

export const copyHTMLtoClipboard = (
  html: JSX.Element,
  description: string
): void => {
  const divElement = document.createElement("div");
  const textAreaElement = document.createElement("textarea");

  divElement.innerHTML = ReactDOMServer.renderToString(html);

  document.body.appendChild(divElement);
  document.body.appendChild(textAreaElement);

  const divElementValue = divElement.innerText;

  textAreaElement.append(divElementValue);

  textAreaElement.select();

  document.execCommand("copy");

  clipboardNotification(description);

  divElement.remove();
  textAreaElement.remove();
};

const clipboardNotification = (description: string): void =>
  notification.open({
    className: "copy-to-clipboard",
    placement: "bottomRight",
    message: (
      <span>
        <FontAwesomeIcon icon={faClipboard} /> Copied to clipboard!
      </span>
    ),
    description: description,
    duration: 5,
  });
